import { PapiUser } from '@wix/da-papi-types';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../publicSession/selectors';

/** returns the currently logged in user (if any) */
export function useCurrentUser(): PapiUser {
  return useSelector(getCurrentUser);
}
